export default __webpack_public_path__ + "static/media/num-04.b04f4289.svg";